import { Image as AntdImage } from "@empglabs/backoffice-ui-kit"

const Image = props => {
  return <AntdImage {...props} />
}

export default Image
